import {
  ADD_CLAIM_TO_SAISINE_REQUEST,
  ADD_SAISINE_ERROR,
  ADD_SAISINE_SUCCESS_FLAG,
  AUTOFILL_APPLY_REQUEST,
  AUTOFILL_APPLY_RESPONSE,
  AUTOFILL_PREVIEW_REQUEST,
  AUTOFILL_PREVIEW_RESPONSE,
  CLEAR_AUTOFILL,
  CLEAR_ELIGIBLE_CLAIMS,
  CLEAR_SAISINE_STATE,
  CREATE_SAISINE_REQUEST,
  CREATE_SAISINE_RESPONSE,
  DELETE_SAISINE_REQUEST,
  DELETE_SAISINE_RESPONSE,
  DISMISS_SAISINE_FLAG_ERROR,
  GENERATE_SAISINE_DOCS_REQUEST,
  GENERATE_SAISINE_DOCS_RESPONSE,
  REMOVE_CLAIM_FROM_SAISINE_REQUEST,
  RETRIEVE_SAISINE_REQUEST,
  RETRIEVE_SAISINE_RESPONSE,
  RETRIEVE_SAISINES_ERROR,
  RETRIEVE_SAISINES_REQUEST,
  RETRIEVE_SAISINES_RESPONSE,
  SEARCH_ELIGIBLE_CLAIMS_REQUEST,
  SEARCH_ELIGIBLE_CLAIMS_RESPONSE,
  VALIDATE_SAISINE_REQUEST,
} from './saisine.actions';

const { v4: uuidv4 } = require('uuid');

export const SAISINE_ERROR_LABELS = {
  INVALID_STATUS: 'Le dossier n\'est pas en statut « MeD envoyée » ou « Saisine à envoyer »',
  ALREADY_IN_SAISINE: 'Le dossier est déjà dans une saisine',
  JURISDICTION_MISMATCH: 'Le dossier ne dépend pas de la même juridiction que la saisine',
  AIRLINE_MISMATCH: 'Le dossier ne concerne pas la même compagnie',
  DATE_WINDOW_EXCEEDED: 'Le vol sort de la fenêtre de 30 jours de la saisine',
  INVALID_AMOUNT: 'Le montant du dossier est invalide',
  MISSING_JURISDICTION: 'Le dossier n\'a pas de juridiction ou de compagnie renseignée',
  MISSING_DATE: 'Le dossier n\'a pas de date de vol',
  CAP_EXCEEDED: 'Le plafond de 5 000 € serait dépassé',
  CAP_OR_WINDOW_EXCEEDED: 'Ajout refusé : plafond ou fenêtre de dates dépassé entre-temps',
  CAP_EXCEEDED_AFTER_EDIT: 'Le total recalculé dépasse 5 000 €',
  CLAIM_STATUS_CHANGED: 'Un dossier a changé de statut depuis son ajout',
  COMPENSATION_DRIFT: 'Le montant d\'un dossier a changé depuis son ajout',
  SAISINE_SENT: 'La saisine a déjà été envoyée',
  SAISINE_NOT_FOUND: 'Saisine introuvable',
  CLAIM_NOT_FOUND: 'Dossier introuvable',
  EMPTY_SAISINE: 'La saisine ne contient aucun dossier',
  TOO_BIG: 'Dépasse 5 000 € à lui seul',
  SINGLETON: 'Seul dans sa juridiction sur la période',
};

export const saisineErrorLabel = (code) => SAISINE_ERROR_LABELS[code] || code || 'Une erreur est survenue';

const initialSaisineState = {
  list: [],
  total: 0,
  saisine: null,
  rejected: [],
  eligibleClaims: [],
  autofill: null,
  autofillReport: null,
  loadingState: {
    list: false,
    saisine: false,
    eligible: false,
    action: false,
    autofill: false,
  },
  errorsInfo: [],
};

function getFlag(id, title, appearance) {
  return {
    created: Date.now(),
    id,
    key: id,
    title,
    appearance,
  };
}

function withFlag(state, title, appearance) {
  const errorsInfo = [...state.errorsInfo];
  errorsInfo.unshift(getFlag(uuidv4(), title, appearance));
  return errorsInfo;
}

export const saisineReducer = (state = initialSaisineState, action) => {
  switch (action.type) {
    case CLEAR_SAISINE_STATE:
      return {
        ...initialSaisineState,
        errorsInfo: state.errorsInfo,
      };

    case RETRIEVE_SAISINES_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, list: true },
      };

    case RETRIEVE_SAISINES_RESPONSE:
      return {
        ...state,
        loadingState: { ...state.loadingState, list: false },
        list: action.payload.saisines,
        total: action.payload.total,
      };

    case RETRIEVE_SAISINES_ERROR:
      return {
        ...state,
        loadingState: { ...state.loadingState, list: false },
        errorsInfo: withFlag(state, saisineErrorLabel(action.payload && action.payload.message), 'error'),
      };

    case RETRIEVE_SAISINE_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, saisine: true },
      };

    case RETRIEVE_SAISINE_RESPONSE:
      return {
        ...state,
        loadingState: { ...state.loadingState, saisine: false, action: false },
        saisine: action.payload,
      };

    case CREATE_SAISINE_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, action: true },
        rejected: [],
      };

    case CREATE_SAISINE_RESPONSE: {
      const { saisine, rejected } = action.payload;
      const errorsInfo = rejected.length
        ? withFlag(state, `${rejected.length} dossier(s) non ajouté(s) : ${rejected.map((r) => saisineErrorLabel(r.code)).join(', ')}`, 'warning')
        : state.errorsInfo;
      return {
        ...state,
        loadingState: { ...state.loadingState, action: false },
        saisine,
        rejected,
        errorsInfo,
      };
    }

    case ADD_CLAIM_TO_SAISINE_REQUEST:
    case REMOVE_CLAIM_FROM_SAISINE_REQUEST:
    case VALIDATE_SAISINE_REQUEST:
    case DELETE_SAISINE_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, action: true },
      };

    case DELETE_SAISINE_RESPONSE:
      return {
        ...state,
        loadingState: { ...state.loadingState, action: false },
        saisine: null,
        errorsInfo: withFlag(state, 'Saisine supprimée', 'success'),
      };

    case SEARCH_ELIGIBLE_CLAIMS_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, eligible: true },
      };

    case SEARCH_ELIGIBLE_CLAIMS_RESPONSE:
      return {
        ...state,
        loadingState: { ...state.loadingState, eligible: false },
        eligibleClaims: action.payload,
      };

    case CLEAR_ELIGIBLE_CLAIMS:
      return {
        ...state,
        eligibleClaims: [],
      };

    case GENERATE_SAISINE_DOCS_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, action: true },
      };

    case GENERATE_SAISINE_DOCS_RESPONSE:
      return {
        ...state,
        loadingState: { ...state.loadingState, action: false },
        errorsInfo: withFlag(state, 'Génération des documents lancée', 'success'),
      };

    case AUTOFILL_PREVIEW_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, autofill: true },
        autofill: null,
        autofillReport: null,
      };

    case AUTOFILL_PREVIEW_RESPONSE:
      return {
        ...state,
        loadingState: { ...state.loadingState, autofill: false },
        autofill: action.payload,
      };

    case AUTOFILL_APPLY_REQUEST:
      return {
        ...state,
        loadingState: { ...state.loadingState, autofill: true },
      };

    case AUTOFILL_APPLY_RESPONSE: {
      const { report, applied } = action.payload;
      const appliedNewKeys = new Set((applied.newRooms || [])
        .map((claimIds) => claimIds.slice().sort().join(',')));
      const appliedTopUpIds = new Set((applied.topUps || [])
        .map((topUp) => String(topUp.saisineId)));

      const remainingNewRooms = ((state.autofill && state.autofill.newRooms) || [])
        .filter((room) => !appliedNewKeys.has(room.claims.map((claim) => String(claim._id)).sort().join(',')));
      const remainingTopUps = ((state.autofill && state.autofill.topUps) || [])
        .filter((room) => !appliedTopUpIds.has(String(room.saisineId)));

      const autofill = remainingNewRooms.length || remainingTopUps.length
        ? { ...state.autofill, newRooms: remainingNewRooms, topUps: remainingTopUps }
        : null;

      return {
        ...state,
        loadingState: { ...state.loadingState, autofill: false },
        autofill,
        autofillReport: report,
        errorsInfo: withFlag(
          state,
          `${report.created.length} saisine(s) créée(s), ${report.toppedUp.length} complétée(s), ${report.skipped.length} dossier(s) sauté(s)`,
          'success',
        ),
      };
    }

    case CLEAR_AUTOFILL:
      return {
        ...state,
        autofill: null,
        autofillReport: null,
      };

    case ADD_SAISINE_SUCCESS_FLAG:
      return {
        ...state,
        loadingState: { ...state.loadingState, action: false },
        errorsInfo: withFlag(state, action.payload, 'success'),
      };

    case ADD_SAISINE_ERROR: {
      const code = action.payload && action.payload.message;
      return {
        ...state,
        loadingState: {
          ...state.loadingState,
          list: false,
          saisine: false,
          eligible: false,
          action: false,
          autofill: false,
        },
        errorsInfo: withFlag(state, saisineErrorLabel(code), 'error'),
      };
    }

    case DISMISS_SAISINE_FLAG_ERROR:
      return {
        ...state,
        errorsInfo: state.errorsInfo.slice(1),
      };

    default:
      return state;
  }
};
